"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  rpc: {},
  types: {
    VotingInfo: {
      votingOption: 'u32',
      numberOfVotes: 'Balance',
      ceresWithdrawn: 'bool'
    },
    PollInfo: {
      numberOfOptions: 'u32',
      pollStartTimestamp: 'Moment',
      pollEndTimestamp: 'Moment'
    }
  }
};
exports.default = _default;